import { IChatMessage } from "dto/Chat/IChatMessage";
import { createContext } from "react";

type IChatMessagesContext = {
  messages: IChatMessage[];
  setMessages: (messages: IChatMessage[]) => void;
};

const ChatMessagesContext = createContext<IChatMessagesContext>({
  messages: [],
  setMessages: () => {},
});

export default ChatMessagesContext;
